<div class="global-overlay-page">


  @if (displayCsmReport) {
  <div style="width: 100%">
    <app-csm-report [code]="displayCsmReport" [codeDescription]="csmReportDescription" [clientName]="clientName"
      (close)="closeCsmReport($event)"></app-csm-report>
  </div>
  }


  <div style="display: flex; justify-content: center;padding:20px;">
    <div [hidden]="displayCsmReport || shareUserGuides" style="width:100%;">

      <div class="menu">
        <input #filterInput type="text" (keyup)="filter($event)" [value]="codeFilter" placeholder="Filter codes" />


        <div class="opposite">
          <div class="toolbar">
            @if (clientId) {
            <a (click)="newCode()">New Code</a>
            }
          </div>

          <div class="client-name">{{clientName}}</div>

        </div>

      </div>

      <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>
        <ng-container matColumnDef="client_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Client</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.client_name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
        </ng-container>

        @for (column of columnNames; track column.id) {
        <ng-container matColumnDef="{{ column.id }}">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.value }}</mat-header-cell>
          @if (column.id === 'created' || column.id === 'ts' || column.id === 'content_last_updated') {
          <mat-cell *matCellDef="let element"> {{ element[column.id] | date:'dd-MM-yy h:mm a' }}</mat-cell>
          } @else {
          <mat-cell *matCellDef="let element"> {{ element[column.id] }}</mat-cell>
          }
        </ng-container>
        }

        <ng-container matColumnDef="stencil">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Template</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.stencil" [disabled]="true"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Active</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.active" [disabled]="true"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="action-container" (mouseleave)="onMouseLeave()" (mouseenter)="onMouseEnter(element.id)">
              <a class="menu-trigger" (click)="toggleMenu(element.id, $event)"
                [class.active]="activeMenuId === element.id">
                <mat-icon>more_vert</mat-icon>
              </a>
              <div class="row-toolbar" [class.visible]="activeMenuId === element.id">
                <a class="action-btn" (click)="loadContent(element.id)">Content</a>
                <a class="action-btn" (click)="editCode(element.id)">Edit</a>
                <a class="action-btn" (click)="openDuplicateCode(element.id)">Duplicate</a>
                <a class="action-btn" (click)="previewLibrary(element.code)">Library</a>
                <a class="action-btn" (click)="copySmartURL(element.code)">Smart URL</a>
                <a class="action-btn" (click)="downloadUserGuide(element.code)">User guide</a>
                <a class="action-btn" (click)="downloadGovernorsReport(element.code)">
                  @if (element.kind == 'EDUCATION') {
                  <span>Annual</span>
                  }
                  @if (element.kind != 'EDUCATION') {
                  <span>Executive</span>
                  }
                  report</a>
                <a class="action-btn" (click)="showCsmReport(element.code, element.description)">CSM Report</a>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      <div style="display: flex; justify-content: center;">
        <mat-paginator [length]="count" [pageSize]="10" (page)="onPaginateChange($event)" showFirstLastButtons
          hidePageSize="true">
        </mat-paginator>
      </div>


    </div>


  </div>

  <!-- Modal Overlay for Code Detail -->
  @if (code) {
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <app-code-detail [code]="code" (close)="closeCodeDetail($event)"></app-code-detail>
    </div>
  </div>
  }

  <!-- Modal Overlay for Duplicate Code -->
  @if (duplicatingCode) {
  <div class="modal-overlay" (click)="dismissDuplicateCode()">
    <div class="duplicate-code-modal" (click)="$event.stopPropagation()">
      <div class="duplicate-code-header">
        <div class="duplicate-code-title">Duplicate code</div>
        <button class="duplicate-code-close" (click)="dismissDuplicateCode()">&#x2715;</button>
      </div>

      <div class="duplicate-code-body">
        <p>Duplicate <strong>{{duplicatingCode.code}} - {{duplicatingCode.description}}</strong> to:</p>

        <mat-form-field appearance="outline" class="duplicate-code-select-field">
          <input type="text" matInput autocomplete="off" placeholder="Search for a client..."
            [(ngModel)]="duplicateClientSearchText" (ngModelChange)="onDuplicateClientSearchChange($event)"
            [matAutocomplete]="duplicateClientAuto">
          <mat-autocomplete #duplicateClientAuto="matAutocomplete" [displayWith]="displayDuplicateClient"
            (optionSelected)="onDuplicateClientSelected($event)">
            @for (client of filteredDuplicateClients; track client.id) {
            <mat-option [value]="client">
              {{client.name}}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        @if (duplicateError) {
        <p class="duplicate-code-error">{{duplicateError}}</p>
        }
      </div>

      <div class="duplicate-code-footer">
        <button class="duplicate-code-cancel" (click)="dismissDuplicateCode()">Cancel</button>
        <button class="duplicate-code-confirm" [disabled]="!duplicateTargetClientId || duplicating"
          (click)="confirmDuplicateCode()">
          {{ duplicating ? 'Duplicating...' : 'Duplicate' }}
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Modal Overlay for Duplicate Code Success -->
  @if (duplicatedCode) {
  <div class="modal-overlay" (click)="closeDuplicatedCode()">
    <div class="duplicate-code-modal" (click)="$event.stopPropagation()">
      <div class="duplicate-code-header">
        <div class="duplicate-code-title">Code duplicated</div>
        <button class="duplicate-code-close" (click)="closeDuplicatedCode()">&#x2715;</button>
      </div>

      <div class="duplicate-code-body">
        <p>The code was duplicated successfully. New code:</p>
        <p><strong>{{duplicatedCode}}</strong></p>
      </div>

      <div class="duplicate-code-footer">
        <button class="duplicate-code-confirm" (click)="closeDuplicatedCode()">OK</button>
      </div>
    </div>
  </div>
  }

  <div class="shareUserGuides">
    @if (shareUserGuides) {
    <app-share-user-guides (close)="shareUserguideToggle()" [clientKind]="clientKind"
      [clientId]="clientId"></app-share-user-guides>
    }
  </div>


  @if( clientId > 0 ){
  <div class="autoAdd">
    <mat-table #tableSchedule [dataSource]="scheduleDataSource" matSort>
      <ng-container matColumnDef="existing">
        <mat-header-cell *matHeaderCellDef>Existing code</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.e_code}} - {{element.e_description}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="add">
        <mat-header-cell *matHeaderCellDef>Add Code</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.a_code}} - {{element.a_description}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="onDate">
        <mat-header-cell *matHeaderCellDef>On Date</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.on_date}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="remove">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element"><a (click)="removeSchedule(element.id)">remove</a></mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="scheduleDisplayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: scheduleDisplayedColumns"></mat-row>
    </mat-table>
    <hr>
    <p>
      For users with code <select #existingCode>
        @for (code of codes; track code.id) {
        <option [value]="code.id">{{code.code}} - {{code.description}}</option>
        }
      </select>,
      add code <select #addCode>
        @for (code of codes; track code.id) {
        <option [value]="code.id">{{code.code}} - {{code.description}}</option>
        }
      </select>
      on <input type="date" #addDate [min]="fromDate" />
      <button (click)="addAutoCode()">Add</button>
    </p>
  </div>
  }

  @if (showSmartUrlCopied) {
  <div class="flash-message">
    <mat-icon>check_circle</mat-icon>
    <span>{{showSmartUrlCopied}} Smart URL Copied!</span>
  </div>
  }
</div>
